import React, { useEffect, useState } from "react";
import walletC from "../Assets/walletC.svg";
import qr from "../Assets/qr.PNG";
import { AiOutlineClose } from "react-icons/ai";
import { othersWallet } from "../utils/mockup.js";
import { CgSpinner } from "react-icons/cg";

const WalletConnectModal = ({ setWalletCn, setModal, setImportWallet }) => {
  const [active, setActive] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const itemsPerPage = 12;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = searchResults.slice(indexOfFirstItem, indexOfLastItem);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(othersWallet.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  React.useEffect(() => {
    // Filter the data based on the search term
    const filteredData = othersWallet.filter((item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    setSearchResults(filteredData);
  }, [searchTerm]);
  return (
    <section className="fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 md:p-6 bg-black/30">
      {loading ? (
        <div className="flex items-center justify-center w-full max-w-md bg-white rounded-lg h-80 drop-shadow-2xl">
          <CgSpinner className="text-blue-500 animate-spin" size={30} />
        </div>
      ) : (
        <div className="w-full max-w-xl">
          {/* Header */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center space-x-2">
              <img src={walletC} alt="walletC" className="w-10" />
              <p className="text-xl font-semibold text-white">WalletConnect</p>
            </div>
            <AiOutlineClose
              onClick={() => setWalletCn(false)}
              className="p-1 text-3xl text-black bg-white rounded-full cursor-pointer"
            />
          </div>

          {/* Modal Body */}
          <div className="w-full bg-white rounded-3xl drop-shadow-2xl">
            <div className="flex flex-col items-center p-4 space-y-4 sm:p-6 lg:p-8">
              {/* Toggle Buttons */}
              <div className="bg-[#d4d5d9] flex w-full max-w-md space-x-2 items-center rounded-md p-1">
                {[
                  { name: "QR Code", id: 1 },
                  { name: "Desktop", id: 2 },
                ].map((item) => (
                  <button
                    key={item.id}
                    onClick={() => setActive(item.id)}
                    className={`w-full py-1 px-4 text-sm md:text-base rounded-md ${
                      item.id === active ? "bg-white" : "text-black"
                    }`}
                  >
                    {item.name}
                  </button>
                ))}
              </div>

              {/* Description */}
              <p className="text-center text-sm md:text-lg text-[#767676] font-bold">
                {active === 2
                  ? "Choose your preferred wallet"
                  : "Scan QR code with a WalletConnect-compatible wallet"}
              </p>

              {/* Search Input */}
              {active === 2 && (
                <input
                  value={searchTerm}
                  onChange={handleChange}
                  placeholder="Search"
                  className="w-full bg-[#d4d5d9] rounded-md px-4 py-2 outline-none"
                />
              )}

              {/* Wallet Options or QR Code */}
              {active === 2 ? (
                <>
                  <div className="grid w-full grid-cols-3 gap-2 sm:grid-cols-4">
                    {currentData.map((item) => (
                      <div
                        key={item.id}
                        className="flex flex-col items-center gap-1 p-2 text-center cursor-pointer hover:opacity-80 rounded-xl"
                        onClick={() => {
                          setWalletCn(false);
                          setModal(false);
                          setImportWallet(true);
                        }}
                      >
                        <img
                          src={item.icon}
                          alt={item.name}
                          className="w-6 md:w-7"
                        />
                        <p className="text-xs font-semibold text-black md:text-sm">
                          {item.name}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Pagination */}
                  <div className="flex items-center justify-center mt-3 space-x-2">
                    {pageNumbers.map((number) => (
                      <button
                        key={number}
                        className="px-2 py-1 text-black border rounded-md"
                        onClick={() => handlePageChange(number)}
                      >
                        {number}
                      </button>
                    ))}
                  </div>
                </>
              ) : (
                <>
                  <img
                    src={qr}
                    alt="QR code"
                    className="w-40 sm:w-48 md:w-56"
                  />
                  <p className="mt-2 text-blue-500 cursor-pointer">
                    Copy to clipboard
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default WalletConnectModal;
